<p-speedDial
    #fab
    [model]="items"
    className="speeddial-left"
    direction="up"
    [rotateAnimation]="!simple"
    [showIcon]="computeIcon()">
    <ng-template let-item pTemplate="item">
        <div class="fab-item">
            <i [class]="item.icon"></i>
            <span *ngIf="item.label" class="fab-item-label">{{ item.label }}</span>
        </div>
    </ng-template>
</p-speedDial>
